<button class="back-button" (click)="onGoBack()" [ngClass]="{ link: hasLinkStyle }">
  <span class="icon icon-arrow-left"></span>
  <span class="back-button-label">{{
    "browse.search.toolbar.back" | translate
  }}</span>
</button>
